import React from "react";
import styled from "styled-components";
import { color } from "styled-system";

const Comp = styled.section`
  padding: 0 7.5vw;
  ${color};
`;

const SectionWrapper = ({ children, bg, ...rest }) => (
  <Comp bg={bg} {...rest}>
    <div
      css={`
        display: flex;
        width: 100%;
        max-width: 80rem;
        margin: 0 auto;
      `}
    >
      {children}
    </div>
  </Comp>
);

SectionWrapper.defaultProps = {
  bg: "bg.default"
};

export default SectionWrapper;
